import React from 'react';
import './Button.css';

export const Button = ({ text }) => (
  <button className="button is-info">{text}</button>
);
